import { render, staticRenderFns } from "./IntroVideo.vue?vue&type=template&id=38be1e65&scoped=true"
import script from "./IntroVideo.vue?vue&type=script&lang=js"
export * from "./IntroVideo.vue?vue&type=script&lang=js"
import style0 from "./IntroVideo.vue?vue&type=style&index=0&id=38be1e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be1e65",
  null
  
)

export default component.exports